import React from 'react';
import currencyFormatter from 'common/currencyFormatter';
import dateUtility from 'common/DateUtility';
import { PaymentTypes } from 'common/constants';

import {
    ServiceNotesSection,
    SkylineHeader,
    InvoiceRow,
    HorizontalDivider,
    ThankYouSection   
} from './InvoiceCommon';

const localStyles = {
    chargeEntry: {
        paddingTop: "10px",
        width: "400px",
        display: "inlineBlock"
    },
    chargeEntryNameLarge: {
        marginRight: "10px",
        textAlign: "right",
        width: "210px",
        display: "inline-block",
        fontWeight: 600,
        fontSize: "large"
    },
    chargeEntryTextLarge: {
        fontSize: "large",
        display: "inline-block",
        marginLeft: "20px"
    },    
    entryChargeText: {
        display: "inline-block",
        marginLeft: "20px"
    },
    entryText: {
        maxWidth: "60%",
        display: "inline-block"
    },
    entryTextBold: {
        maxWidth: "60%",
        display: "inline-block",
        fontWeight: 600
    },
    partItem: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "50%"
    },
    partsItems: {
        display: "flex",
        flexWrap: "wrap",
        padding: "8px 45px 0",
        fontSize: "0.9em"
    },
    partsNotesHeader: {
        paddingTop: "5px",
        paddingLeft: "45px",
        fontWeight: 600
    },
    partsNotesSection: {
        minHeight: "115px"
    },
    shopChargeEntry: {
        paddingTop: "0px",
        width: "400px",
        display: "inline-block"
    },
    invoiceThankYou: {
        fontSize: "larger",
        marginLeft: "auto",
        marginRight: "auto",
        width: "40%",
        fontWeight: 600,
        paddingTop: "60px",
        textAlign: "center"
    },
    skylineSummarySectionContainer: {
        paddingBottom: "10px",
        paddingLeft: "35px"
    }
}

export default function ShopInvoice(props) {
    const { invoice, customer, commonStyles ,imageSrc} = props;
    const styles = { ...localStyles, ...commonStyles};    

    const summarySection = () => {                
        const date = invoice.date ? dateUtility.dateToString(invoice.date,'M/D/YYYY') : "";                
        return (
            <div>
                <HorizontalDivider/>
                <div style={styles.skylineSummarySectionContainer}>
                    <InvoiceRow leftText={'Customer'} 
                                leftEntry={customer.name} 
                                rightText={'Invoice #'} 
                                rightEntry={`S${invoice.id}`} 
                                styleRight={styles.entryTextBold} 
                                id={"invoiceId"}/>
                    <InvoiceRow leftText={'Address'} leftEntry={customer.street}/>
                    <InvoiceRow leftText={'City'} leftEntry={customer.city} rightText={'Date'} rightEntry={date}/>
                    <InvoiceRow leftText={'State'} leftEntry={customer.state} rightText={'Unit #'} rightEntry={invoice.unit}/>
                    <InvoiceRow leftText={'Zip'} leftEntry={customer.zipcode} rightText={'Vehicle'} rightEntry={invoice.vehicle}/>
                    <InvoiceRow leftText={'Phone'} leftEntry={customer.phone} rightText={'VIN'} rightEntry={invoice.vin}/>
                    <InvoiceRow leftText={'Reference #'} leftEntry={invoice.referenceNumber} rightText={'Location'} rightEntry={invoice.location}/>
                    <InvoiceRow leftText={'Company PO #'} leftEntry={invoice.companyPO} rightText={'Mileage'} rightEntry={invoice.mileage}/>
                </div>
                <HorizontalDivider/>
            </div>
        )
    }

    const partsSection = () => {
        const {parts} = invoice;
        return invoice.parts && invoice.parts.length > 0 ? (
            <div style={styles.partsNotesSection}>
                <div style={styles.partsNotesHeader}>Parts</div>
                <div style={styles.partsItems}>
                    {parts.map((part, index) => (<div key={`part${index}`} style={styles.partItem}>
                        <div id={`partNumber${index}`}>{part.partNumber}</div>
                        <div id={`partPrice${index}`}>{currencyFormatter.formatUSD(part.price)}</div>
                    </div>)
                    )}
                </div>
            </div>
        ) : (
                <div style={styles.partsNotesSection}>
                    <div style={styles.partsNotesHeader}>Parts</div>
                    <div style={styles.partsItems}></div>
                </div>
            );
    }

    const invoiceChargeEntry = (text,entry) => {        
        const entryId = text.split(' ').join('-').toLowerCase();
        return (            
            <div style={styles.shopChargeEntry} id={entryId}>
                <div style={styles.chargeEntryName}>{text}: </div><div style={styles.entryChargeText}>{currencyFormatter.formatUSD(entry)}</div>
            </div>
        )
    }
   
    const invoiceChargeEntryLarge = (text,entry) => {
        return (            
            <div style={styles.chargeEntry}>
                <div style={styles.chargeEntryNameLarge}>{text}: </div><div style={styles.chargeEntryTextLarge}>{currencyFormatter.formatUSD(entry)}</div>
            </div>
        )
    }

    const invoiceChargeNonMonetaryEntry = (text,entry) => {
        const entryId = text.split(' ').join('-').toLowerCase();
        const separator = text === "" && entry === "" ? "" : ":"
        return (            
            <div style={styles.shopChargeEntry}>
                <div style={styles.chargeEntryName}>{text}{separator}</div><div id={entryId} style={styles.entryChargeText}>{entry}</div>
            </div>
        )
    }

    const invoiceChargesRow = (left,right) => {
        return (
            <div style={styles.invoiceEntryParent}>
                {left}
                {right}
            </div>            
        )
    }

    const chargesSection = () => {        
        const paymentDate = invoice.paymentDate ? dateUtility.dateToString(invoice.paymentDate,'M/D/YYYY') : "";                 
        
        return (
            <div styles={styles.chargesSection}> 
                <div style={styles.shopChargeEntry}>
                    <div style={styles.chargeEntryName}>Payment Type:</div> 
                    <div style={styles.entryChargeText}>{PaymentTypes[invoice.paymentType]}</div>
                </div>
                {invoiceChargesRow(invoiceChargeEntry('Service Truck', invoice.serviceTruckCharges),
                                        invoiceChargeEntry('Misc. Charges',invoice.miscCharges))}
                {invoiceChargesRow(invoiceChargeEntry('Labor',invoice.laborCharges),
                                        invoiceChargeEntry('Credits',invoice.credits))}
                {invoiceChargesRow(invoiceChargeEntry('Parts',invoice.partsCharges),
                                        invoiceChargeEntry('Posted To Receivables',invoice.postedToReceivables))}
                {invoiceChargesRow(invoiceChargeEntry('Taxes',invoice.taxes),
                                        invoiceChargeNonMonetaryEntry('Payment Date',paymentDate))}                
                {invoiceChargesRow(invoiceChargeNonMonetaryEntry("",""),
                                        invoiceChargeEntryLarge('Invoice Total',invoice.invoiceTotal))}
            </div>
        )
    }
    
    return (
        <div id="capture" style={styles.page}>
            <SkylineHeader isShopInvoice={true} imageSrc={imageSrc}/>
            {summarySection()}
            <ServiceNotesSection serviceNotes={invoice.serviceNotes}/>
            <HorizontalDivider/>
            {partsSection()}
            <HorizontalDivider/>
            {chargesSection()}
            <ThankYouSection/>
        </div>
    );

}



